<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="findlog-content">
      <div>
        <p>数据查询记录</p>
        <p>
          筛选:
          <a-date-picker @change="search" placeholder="请选择" />
        </p>
      </div>
      <s-table style="min-height:400px;" rowKey="row_num" :showSizeChanger="false" :expandIconAsCell="false" :expandedRowKeys="expandedRowKeys" :data="loadData" ref="table" class="tb-log" :expandRowByClick="true">
        <div slot="expandedRowRender" slot-scope="record">
          <ul>
            <li v-for="(v,k) in record.detail" :key="`${record.row_num}-${k}`">
              <div> 
                <span>{{ `${(()=>{switch (parseInt(record.search_type)) {case 1:return '查询类型:采购商查询';case 2:return '查询类型:展会名录查询';default:return '';} })()}`}}</span>
                <span>{{`${(()=>{switch (parseInt(record.search_type)) {case 1:return '采购商';case 2:return '展会名录';default:return '';} })()}`}}: {{v.name}}</span>
                <span>{{v.time}}</span>
              </div>
            </li>
          </ul>
        </div>
        <a-table-column dataIndex="date" :width="200"></a-table-column>
        <a-table-column dataIndex="search_type" :customRender="(record)=>{ switch (parseInt(record)) {case 1:return '查询类型:采购商查询';case 2:return '查询类型:展会名录查询';default:return '';} }"> </a-table-column>
        <a-table-column dataIndex="count" :customRender="(record)=>`查询数据${record}条`" :width="150"> </a-table-column>
        <a-table-column dataIndex="action" :width="100">
          <span slot-scope="text, record">
            <a @click="expandedRow(record)">
              <a-icon :type="`double-${expandedRowKeys.includes(record.row_num)&&'left'||'right'}`" class="expand-icon" />
              {{expandedRowKeys.includes(record.row_num)&&'收起'||'展开'}}
            </a>
          </span>
        </a-table-column>
      </s-table>
    </div>
  </a-layout-content>
</template>
<script>
import Banner from "./banner";
export default {
  components: { "s-banner": Banner },
  data() {
    return {
      expandedRowKeys: [1, 2, 3],
      pageNo: 1,
      pageSize: 20,
      queryDate: ""
    };
  },
  methods: {
    search(_, date) {
      this.queryDate = date;
      this.$refs.table.refresh();
    },
    expandedRow(record) {
      console.log(record);

      if (this.expandedRowKeys.includes(record.row_num)) {
        this.expandedRowKeys = [];
        return;
      }

      this.$http
        .post("/zzQueryRecordDetail", {
          type: record.search_type,
          date: record.date
        })
        .then(res => {
          if (!res.error) {
            this.$set(record, "detail", res.data.list);
          }
          this.expandedRowKeys = [record.row_num];
        });
      // this.expandedRowKeys = (!this.expandedRowKeys.includes(id) && [id]) || [];
    },
    loadData(p) {
      return this.$http
        .post("/zzQueryRecordList", {
          pageNo: (p && p.pageNo) || 1,
          pageSize: (p && p.pageSize) || this.pageSize,
          date: this.queryDate
        })
        .then(res => {
          if (!res.error) {
            var a = {
              pageNo: parseInt(res.pageNo),
              totalCount: parseInt(res.totalCount),
              result: res.data.list
            };
            console.log(a);
            return a;
          }
        });
    }
  }
};
</script>
<style lang="scss" >
.tb-log {
  .ant-table-pagination.ant-pagination {
    float: none;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 16px;
    color: #333;
    font-size: 13px;
  }
  .expand-icon {
    transform: rotate(90deg) scale(0.8);
  }
  .ant-table-thead,
  .ant-table-row-expand-icon {
    display: none;
  }
  .ant-table-expanded-row {
    background-color: #fff;
    ul {
      list-style: decimal;

      max-height: 290px;
      overflow-y: auto;
      li {
        div {
          display: flex;
          flex-flow: row;
          span {
            display: inline-block;
            margin: 5px 30px;
            font-size: 13px;
            color: #666;
            &:nth-child(2) {
              flex: 1;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.findlog-content {
  min-height: 750px;
  & > div:first-child {
    display: flex;
    flex-flow: row;
    & > p {
      display: inline-block;
      line-height: 40px;
      margin: 0;
      font-size: 13px;
      color: #999;
      &:first-child {
        flex: 1;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
    }
  }
}
</style>

